export default function MockCarteira() {
  return (
    <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-50">
      <img
        src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/c60aab936d22f9f055b51109d0ab4943.png"
        alt="Catálogo de prêmios da plataforma get points com grade de recompensas, filtros por categoria e painel de detalhes do prêmio para resgate"
        title="Catálogo de prêmios e resgates da plataforma"
        className="block h-auto w-full"
      />
    </div>
  );
}